import DateTimePicker from "react-datetime-picker";
import 'react-datetime-picker/dist/DateTimePicker.css';
import 'react-calendar/dist/Calendar.css';
import 'react-clock/dist/Clock.css';

export default function DatePicker(props){
    return(
        <DateTimePicker format={props?.disableClock ? 'dd MMMM yyyy' : 'dd MMMM yyyy HH:mm'}
            disableClock={props?.disableClock || true}
            clearIcon={false}
            onChange={props?.onChange}
            value={props?.value} 
            className={props?.className || 'h-[38px] w-full bg-white text-sm'}
            disabled={props?.disabled}
        />
    )
}